import { useContext } from 'react'

import { useNumericParams } from '@domain-group/react-hooks'

import { DashboardModuleListItem, Text } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import SecuredText from '@components/SecuredText'

import { DataStoreItemData } from '@functions/groupDataStoreItems'

import useActivity from '@hooks/useActivity'
import useDataStoreItem from '@hooks/useDataStoreItem'

interface DataStoreItemProps {
  dataStoreItem: DataStoreItemData,
  isLastItem: boolean,
}

const DataStoreItem = (props: DataStoreItemProps) => {
  const {
    dataStoreItem,
    dataStoreItem: { display_label },
    isLastItem,
  } = props

  const { campaignId } = useNumericParams()

  const pageContext = useContext(PageContext)
  const {
    callbacks: { createActivity },
  } = pageContext

  const {
    callbacks: {
      createActivity: createFn,
    },
  } = useActivity()

  const dataStoreItemPayload = useDataStoreItem(dataStoreItem)
  const {
    callbacks: {
      editDataStoreItem,
    },
    dataStoreItem: { label, value },
    secured,
  } = dataStoreItemPayload

  const createActivityPayload = {
    callbacks: {
      action: createFn,
    },
    entityParams: {
      key: 'campaign.viewed_secure_text',
      parameters: { label },
      trackable_id: campaignId,
      trackable_type: 'Campaign',
    },
  }

  return (
    <DashboardModuleListItem
      boxProps={{ borderBottom: isLastItem ? '1px solid' : '1px dashed' }}
      onClick={() => editDataStoreItem()}
      title={display_label || label}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {secured
          ? <SecuredText callbacks={{ action: () => createActivity(createActivityPayload) }} text={value} />
          : <Text color="faintGrey" variant="ellipsis">{value}</Text>}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>

  )
}

export default DataStoreItem
